import AOS from 'aos';

AOS.init({
    duration: 1400,
    once: true,
})